import { type CanvasElementType } from '@blaze-runtime/engine-domain';
import { ComparisonOperator } from '@blaze-shared/api-contracts-domain';
import {
  type FilterOperatorType,
  PredefinedDateTimeOperator,
  type PredefinedOperator,
} from '@blaze-shared/datasets-domain';

export type ContainerFilterType =
  | 'Dropdown'
  | 'DropdownMultiselect'
  | 'Chips'
  | 'ChipsMultiselect'
  | 'DatetimePicker'
  | 'DatetimeDropdown'
  | 'Toggle';

export type ContainerFilterContentMode = 'chip';

export interface ContainerFilterElementConfig {
  elementType: CanvasElementType;
  contentMode?: ContainerFilterContentMode;
  filterOperatorType?: FilterOperatorType;
  predefinedOperators?: PredefinedOperator[];
  operator?: ComparisonOperator;
}

const ALL_PREDEFINED_DATETIME_OPERATORS: PredefinedOperator[] = Object.values(
  PredefinedDateTimeOperator,
);

const CONTAINER_FILTER_ELEMENT_CONFIG: Record<ContainerFilterType, ContainerFilterElementConfig> = {
  Dropdown: { elementType: 'dropdown' },
  DropdownMultiselect: { elementType: 'tags', operator: ComparisonOperator.In },
  Chips: { elementType: 'radio', contentMode: 'chip' },
  ChipsMultiselect: {
    elementType: 'checkbox',
    contentMode: 'chip',
    operator: ComparisonOperator.In,
  },
  DatetimePicker: { elementType: 'datetimeInput', filterOperatorType: 'Setup' },
  DatetimeDropdown: {
    elementType: 'dropdown',
    filterOperatorType: 'Predefined',
    predefinedOperators: ALL_PREDEFINED_DATETIME_OPERATORS,
  },
  Toggle: { elementType: 'dropdown' }, // todo replace with ToggleButton when available
};

export function toContainerFilterElementConfig(
  filterType: ContainerFilterType,
): ContainerFilterElementConfig {
  return CONTAINER_FILTER_ELEMENT_CONFIG[filterType];
}

export function toContainerFilterType(
  config: Pick<ContainerFilterElementConfig, 'elementType' | 'contentMode' | 'filterOperatorType'>,
): ContainerFilterType | undefined {
  const match = (
    Object.entries(CONTAINER_FILTER_ELEMENT_CONFIG) as [
      ContainerFilterType,
      ContainerFilterElementConfig,
    ][]
  ).find(
    ([, candidate]) =>
      candidate.elementType === config.elementType &&
      candidate.contentMode === config.contentMode &&
      candidate.filterOperatorType === config.filterOperatorType,
  );

  return match?.[0];
}
